import moment from 'moment';
export class VouchersByStatusModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get formattedCreatedAt() {
        const placedAt = new Date(this.createdAt);
        return moment(placedAt).format('LLL');
    }
    get customerFullName() {
        if (this.rebate.customerDetail) {
            const { firstName, lastName } = this.rebate.customerDetail;
            return `${firstName} ${lastName}`;
        }
        return '';
    }
    get orderFullName() {
        if (this.order) {
            const { firstName, lastName } = this.order;
            return `${firstName} ${lastName}`;
        }
        return '';
    }
    get orderContactNumber() {
        if (this.order) {
            const { contactDialCode, contactNumber } = this.order;
            return `${contactDialCode} ${contactNumber}`;
        }
        return '';
    }
    get formattedUsedAt() {
        if (this.usedAt) {
            const usedAt = new Date(this.usedAt);
            return moment(usedAt).format('LLL');
        }
        return '';
    }
}
